import { ApiClient } from '../../../infra';
import { toBackend } from '../../../domain';
import { historyPageFromBackend, historyValueFromBackend } from '../../generic/patient-detail/patient-detail.api';
/**
 * O historico que alguem compartilhou por link.
 *
 * Tela PUBLICA: o que autoriza e o codigo do link, e nao a sessao. Por isso ela e
 * a unica que pede por UUID em vez de por id de paciente.
 */
export class SharedHistoryApi {
    constructor() {
        this.client = ApiClient.INSTANCE;
    }
    static { this.INSTANCE = new SharedHistoryApi(); }
    /**
     * O historico que um paciente compartilhou por link.
     *
     * Endpoint PUBLICO (`GET /measurement_history/**` esta no permitAll do
     * `SecurityConfig`), entao abre sem sessao - e o ponto da tela.
     *
     * Pagina no servidor - `number`/`size`. Sao 15 KB por pagina; o caminho antigo
     * pedia um milhao de registros para paginar no cliente, e num dos historicos de
     * QA isso da 40 MB para mostrar 50 linhas.
     *
     * A ordenacao e do SERVIDOR (`sortMeasurementTypeId`/`sortDirection`), no mesmo
     * formato do `sort` da tela: `-153` e frequencia cardiaca decrescente, `date` e a
     * hora crescente. O padrao (`-date`, da mais recente para a mais antiga) nao manda
     * nada - e o que o endpoint faz sem parametro.
     *
     * O 410 tem significado proprio: o link expirou. Chega aqui como `Error` com a
     * mensagem do backend, e o presenter o distingue pelo status.
     */
    async fetchSharedHistory(code, page, size, sort, signal) {
        const params = [`number=${Math.max(0, page - 1)}`, `size=${size}`, ...sortParams(sort)];
        return historyPageFromBackend((await this.client.send('GET', `/measurement_history/${code}?${params.join('&')}`, undefined, signal)));
    }
    /**
     * As leituras que UMA celula do historico compartilhado resumiu.
     *
     * Publico como o resto desta tela: a autorizacao e o proprio codigo do link.
     */
    async fetchBucketReadings(code, measurementTypeId, hour, signal) {
        const query = `measurementTypeId=${measurementTypeId}&hour=${encodeURIComponent(toBackend(hour))}`;
        const readings = (await this.client.send('GET', `/measurement_history/${code}/bucket?${query}`, undefined, signal));
        return readings.map(historyValueFromBackend);
    }
    /** Vincula o paciente do link ao profissional logado. */
    async linkSharedHistoryToProfessional(code) {
        await this.client.send('POST', `/measurement_history/${code}/link_to_professional`);
    }
}
/** O `sort` da tela (`-153`, `date`) nos dois parametros que o backend entende. */
function sortParams(sort) {
    if (!sort) {
        return [];
    }
    const descending = sort.startsWith('-');
    const field = descending ? sort.slice(1) : sort;
    const direction = `sortDirection=${descending ? 'DESC' : 'ASC'}`;
    if (field === 'date') {
        // A hora decrescente e o padrao do endpoint: nao ha o que mandar.
        return descending ? [] : [direction];
    }
    return [`sortMeasurementTypeId=${encodeURIComponent(field)}`, direction];
}
//# sourceMappingURL=shared-history.api.js.map